/**
* 工具
*/
import '@common/polyfill/src/promise'
import ajax from '@finance/ajax'
import domain from '@common/domain'
import cookie from 'js-cookie'

// 判断用户是否登录
export const isLoginCookie = () => {
  return cookie.get('isLogin') === 'true'
}

// 函数执行
export const callbackHandler = (callback, data = {}) => {
  if (typeof callback === 'function') {
    try {
      callback(data)
    } catch (e) {
      console.error('callback Error:', e)
    }
  } else {
    console.error('callback is not a function!')
  }
}

// 查询基础账户信息
export const getUserData = (isNeedUserData = false) => {
  // 需要返回给回调的数据
  // 必须要登录才能请求返回数据
  const userData = {}
  userData.isLogin = isLoginCookie()
  return new Promise((resolve, reject) => {
    if (isNeedUserData && isLoginCookie()) {
      Promise.all([ajax.request({
        url: `${domain.api}/accountws/ws/account/v3/getUserData`
      }), ajax.request({
        url: `${domain.api}/custodyws/ws/fixin/custody/investor/queryStatus`
      })]).then(([result1, result2]) => {
        if (result1.succeed && (result2.succeed || result2.code === '100004')) {
          userData.isOpenAccountAcc = result1.data.bizOwners && result1.data.bizOwners.indexOf('ACC') !== -1
          userData.isOpenAccountCustody = result2.data && result2.data.stockStatus === 1 && (result2.data.registerStatus === 1 || result2.data.registerStatus === 4)
          userData.userPhone = result1.data.registPhone || ''
          userData.userName = result1.data.userName || ''
          resolve(userData)
        } else {
          reject('请求失败，请重试')
        }
      }).catch((error) => {
        reject(error)
      })
    } else {
      resolve(userData)
    }
  })
}

export const mixins = (...list) => {
  return (target) => {
    Object.assign(target.prototype, ...list)
  }
}

export default {
  isLoginCookie,
  callbackHandler,
  mixins,
  getUserData
}



// WEBPACK FOOTER //
// ./node_modules/@finance/login/src/utils.js